import styles from './defaultRow.module.css'
const DefaultRow = (props) => {
    return (

        <div className={`${props.className} ${styles.ctn}`}>
            <img className={`${styles.media} sm5-active-desktop`} src={`${props.mediaSrc}.jpg`} alt="" />
            <img className={`${styles.media} sm5-active-mobile`} src={`${props.mediaSrc}-mobile.jpg `} alt="" />
            <div className={styles.text}>{props.children}</div>
        </div>
    )
}

export default DefaultRow